import request from '@/utils/request'
/*
最近三个月所有日交易汇总
*/
export function getMerchantTotalSales(data) {
  return request({
    url: 'get/merchants/total/sales',
    method: 'post',
    params: data
  })
}
